import React from "react";
import CommonSection from "../shared/commonSection/CommonSection";

const About = () => {
  return (
    <div className="about">
      <CommonSection title={"About Us"} />
    </div>
  );
};

export default About;
